import Icon from '../Icon';

const ChevronLeftPlanner = (props) => {
  const { color, ...rest } = props;
  const fillColor = color || 'var(--color-text-primary)';
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Icon {...rest} viewBox="0 0 18 18">
      <path
        d="M11.25 13.5L6.75 9L11.25 4.5"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default ChevronLeftPlanner;
